//TODO: избавиться от ненужно слайса в redux под названием interactiveShop и перенести его логику сюда
import { background } from '../../constants/background';

const initialState = {
  interactiveShop: getDefaultState(),
};

const reducers = {
  setInteractiveShopBackground(state, { payload: blobBackground }) {
    state.interactiveShop.background = blobBackground;
  },
};

export const interactiveShopSegment = {
  initialState,
  reducers,
};

function getDefaultState() {
  return {
    background,
  };
}
